import {
  Button,
  Card,
  Col,
  Dropdown,
  Modal,
  Row,
  Space,
  Typography,
} from "antd";
import OutletCard from "../outlet/outletCard";
import { useEffect, useMemo, useState } from "react";
import AddOutlet from "../outlet/addOutlet";
import config from "../../config";
import { useDispatch, useSelector } from "react-redux";
import useLocalStorage from "../../hooks/useLocalstorage";
import { CaretDownOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
let locationChanges = [];
const Outlet = () => {
  const [openModal, setOpenModal] = useState(false);
  const [mode, setMode] = useState("add");
  const [outlet, setOutlet] = useState({});
  const [outletArray, setOutletArray] = useState([]);
  const shopDetails = useSelector((state) => state.shopDetails);
  const [loading, setLoading] = useState(false);
  const [mainUserShopDetails, setMainUserShopDetails] = useLocalStorage(
    "mainUserShopDetails",
    []
  );
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectValue, setSelectValue] = useState("main");
  const navigate = useNavigate();
  const handleEdit = (value) => {
    setOutlet(value);
    setOpenModal(true);
    setMode("edit");
  };
  const handleDelete = (value) => {
    setOutlet(value);
    setDeleteModal(true);
  };
  const dispatch = useDispatch();
  const shopProfile = useSelector((state) => state.shopDetails);

  useEffect(() => {
    shopDetails.userType === "Shop" &&
      mainUserShopDetails.length === 0 &&
      fetchOutlets(shopDetails.shopId);
  }, [shopDetails.shopId, shopDetails.userType, mainUserShopDetails]);

  const fetchOutlets = async (shopId) => {
    try {
      var res = await fetch(`${config.newApiGateway}/outlet/getOutlet`, {
        method: "post",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          type: "fetch",
          shopId: shopId,
        }),
      });
      res = await res.json();
      if (res.code === "ERROR") {
        return alert(res.message);
      }
      dispatch({
        type: "SET_OUTLETS",
        payload: res.data,
      });
      setOutletArray(res.data);
    } catch (err) {
      console.log("Err", err);
    }
  };

  const handleClick = () => {
    setOpenModal(true);
    setMode("add");
  };
  const handleClose = () => {
    setOpenModal(false);
  };
  const addOutletHandler = async (values, mode) => {
    setLoading(true);
    var body = {};
    if (mode === "add") {
      body = {
        ...values,
        ownerShopId: shopProfile.shopId,
        type: "add",
      };
    } else {
      body = {
        ...values,
        userId: outlet.userId,
        type: "edit",
      };
    }
    try {
      var res = await fetch(`${config.newApiGateway}/outlet/getOutlet`, {
        method: "post",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });
      res = await res.json();
      if (res.code === "ERROR") {
        return alert(res.message);
      }
      fetchOutlets(shopProfile.shopId);
      setOpenModal(false);
    } catch (err) {
      console.log("Err", err);
    } finally {
      setLoading(false);
    }
  };
  const handleOutletDelete = async () => {
    try {
      var res = await fetch(`${config.newApiGateway}/outlet/getOutlet`, {
        method: "post",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          type: "delete",
          shopId: shopProfile.shopId,
          outletId: outlet.userId,
        }),
      });
      res = await res.json();
      if (res.code === "ERROR") {
        return alert(res.message);
      }
      fetchOutlets(shopProfile.shopId);
      setOpenModal(false);
    } catch (err) {
      console.log("Err", err);
    } finally {
      setLoading(false);
    }
  };

  const handleOutletSelect = (v) => {
    locationChanges.push({
      ...shopProfile,
      userId: shopProfile.shopId,
      settings: shopDetails.settings,
      newBillSettings: shopDetails.newBillSettings,
      userPhoneNumber: shopProfile.phoneNumber,
    });
    setSelectValue(v);
    const outletData = outletArray.find((i) => i.userId === v);
    let updatedShopDetails = {};
    if (v === "main") {
      updatedShopDetails = {
        ...shopProfile,
        outletArea: undefined,
        outletState: undefined,
        shopAddress: mainUserShopDetails[0].shopAddress,
        userId: mainUserShopDetails[0].userId
          ? mainUserShopDetails[0].userId
          : mainUserShopDetails[0].shopId,
        userId10Digit: mainUserShopDetails[0].userId10Digit,
        userPincode: mainUserShopDetails[0].userPincode,
        categoryList: mainUserShopDetails[0].categoryList,
        taxMaster: mainUserShopDetails[0].taxMaster,
        userPhoneNumber: mainUserShopDetails[0].userPhoneNumber,
      };
      setMainUserShopDetails([]);
      locationChanges = [];
      dispatch({
        type: "SET_SETTINGS",
        payload: mainUserShopDetails[0].settings,
      });
    } else {
      updatedShopDetails = {
        ...shopProfile,
        shopAddress: outletData.shopAddress,
        outletArea: outletData.outletArea,
        outletState: outletData.outletState,
        userId: outletData.userId,
        userId10Digit: outletData.userId10Digit,
        userPincode: outletData.userPincode,
        categoryList: outletData.categoryList,
        taxMaster: outletData.taxMaster,
        userPhoneNumber: shopProfile.phoneNumber,
      };
      const data = {
        ...shopProfile,
        shopAddress: outletData.shopAddress,
        outletArea: outletData.outletArea,
        outletState: outletData.outletState,
        userId: outletData.userId,
        userId10Digit: outletData.userId10Digit,
        userPincode: outletData.userPincode,
        categoryList: outletData.categoryList,
        taxMaster: outletData.taxMaster,
        settings: outletData.settings,
      };
      locationChanges.push(data);
      setMainUserShopDetails(locationChanges);
      dispatch({
        type: "SET_SETTINGS",
        payload: outletData.settings,
      });
    }
    dispatch({
      type: "SET_SHOP_PROFILE",
      payload: updatedShopDetails,
    });
    navigate("/dashboard/overview");
  };
  const items = useMemo(() => {
    const mainShop = {
      key: "main",
      label: <span onClick={() => handleOutletSelect("main")}>Main</span>,
    };
    const menuItems = outletArray.map((i) => {
      return {
        key: i.userId,
        label: (
          <span onClick={() => handleOutletSelect(i.userId)}>
            {i.outletArea ? i.outletArea : i.shopAddress}
          </span>
        ),
      };
    });
    return [mainShop, ...menuItems];
  }, [outletArray]);

  return (
    <div>
      <div
        style={{
          position: "relative",
        }}
      >
        <Card
          style={{
            margin: "20px 0",
          }}
          bodyStyle={{
            textAlign: "right",
          }}
        >
          <Button
            style={{
              marginLeft: "auto",
            }}
            type="primary"
            onClick={handleClick}
          >
            + Add outlet
          </Button>
        </Card>
        <Row gutter={[16, 16]}>
          {outletArray.map((data) => (
            <Col span="6" key={data.userId}>
              <OutletCard
                area={data.outletArea}
                address={data.shopAddress}
                onEdit={() => handleEdit(data)}
                onDelete={() => handleDelete(data)}
              />
            </Col>
          ))}
          {outletArray?.length === 0 && (
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50% ,-50%)",
              }}
            >
              No Data to display{" "}
            </div>
          )}
        </Row>
      </div>

      <AddOutlet
        mode={mode}
        show={openModal}
        initialValues={outlet}
        handleClose={handleClose}
        addOutlet={addOutletHandler}
        outlets={outletArray}
        loading={loading}
      />
      <Modal
        open={deleteModal}
        onCancel={() => {
          setDeleteModal(false);
        }}
        width={550}
        closable={false}
        centered
        footer={false}
      >
        <Typography.Title level={5}>
          Are you sure you want to delete this outlet? You cannot undo this
          action, and all data related to this outlet will be lost.
          <br /> Do you still want to proceed?
        </Typography.Title>
        <Space
          style={{
            textAlign: "right",
            justifyContent: "right",
            display: "flex",
            alignItems: "center",
            marginTop: 20,
          }}
          direction="horizontal"
        >
          <Button
            onClick={() => {
              setDeleteModal(false);
            }}
            type="primary"
            ghost
          >
            No
          </Button>
          <Button
            onClick={() => {
              handleOutletDelete();
              setDeleteModal(false);
            }}
            type="primary"
          >
            Yes
          </Button>
        </Space>
      </Modal>
    </div>
  );
};

export default Outlet;
